export const SYSTEM_SETTINGS_STORAGE_KEY = 'catapult:systemSettings';
export const SPORT_LOCALIZATION_STORAGE_KEY = 'catapult:exchangeSportLocalization';
